export enum SFDCObjectType {
  Lead = 'Lead',
  Account = 'Account',
  Opportunity = 'Opportunity',
  Contact = 'Contact',
  Case = 'Case',
}
